import React from 'react';

interface IDropdownArrowProps {
	bold?: boolean;
	size?: string;
	fill?: string;
}

export const DropdownArrowDown = ({ bold = false, size = '24', fill = '#3D3D3D' }: IDropdownArrowProps) =>
	bold ? (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.1566 16.5708L5.82324 11.2374L7.23746 9.82321L11.8637 14.4494L16.4899 9.82321L17.9041 11.2374L12.5708 16.5708C12.1803 16.9613 11.5471 16.9613 11.1566 16.5708Z"
				fill={fill}
			/>
		</svg>
	) : (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.6465 16.2803L3.64648 8.28035L4.35359 7.57324L12 15.2197L19.6465 7.57324L20.3536 8.28035L12.3536 16.2803C12.1583 16.4756 11.8417 16.4756 11.6465 16.2803Z"
				fill={fill}
			/>
		</svg>
	);
